import React from 'react';
import Helmet from 'react-helmet';

import HelpContactUs from '../../../components/HelpContactUs/HelpContactUs';
import SheetTitle from '../../../components/SheetTitle';
import BackButton from '../../../components/BackButton';

import c from '../Help.less';

export default function () {
  return (
    <div className={c.content}>
      <Helmet defer={false}>
        <meta property="mc:dp" content="/shop/help/affiliate-program" />
      </Helmet>
      <BackButton to="/shop/help" />
      <SheetTitle title="Affiliate program" />
      <p>
        If you want to become an affiliate, please contact us.
      </p>
      <HelpContactUs subject={9} />
    </div>
  );
}
